/* Sekce se scrollem řízeným videem.

   Scroll se mapuje na čas ve videu – uživatel tím „přetáčí“ animaci sám.
   Posun se nedává do videa napřímo, ale dotahuje se po snímcích, jinak
   by scrollování po jednotlivých událostech viditelně cukalo. */
(function () {
  'use strict';

  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class RizzScrollVideo extends HTMLElement {
    connectedCallback() {
      this.videos = Array.prototype.slice.call(this.querySelectorAll('[data-sv-video]'));
      this.stage = this.querySelector('[data-sv-stage]');
      /* Postup se měří jen podle dráhy, ne podle celé sekce – nad videem
         i pod ním může být text a ten by se do postupu započítával. */
      this.track = this.querySelector('[data-sv-track]') || this;
      this.pickVideo();
      this.captions = Array.prototype.slice.call(this.querySelectorAll('[data-sv-from]'));

      if (!this.video) return;

      this.onMeta = this.onMeta.bind(this);

      this.smoothing = parseFloat(this.getAttribute('smoothing')) || 0.15;
      this.resolveMode();
      this.target = 0;
      this.current = 0;
      this.progress = 0;
      this.visible = false;
      this.frame = null;
      this.unlocked = false;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.tick = this.tick.bind(this);

      /* Bez znalosti délky se nedá nic mapovat. Když metadata nedorazí
         nebo video délku nehlásí, spadne se do obyčejné smyčky. */
      this.bindMeta();

      this.observer = new IntersectionObserver(
        function (entries) {
          this.visible = entries[0].isIntersecting;
          if (this.visible) {
            this.unlock();
            this.measure();
            this.onScroll();
            this.start();
          } else {
            this.stop();
          }
        }.bind(this),
        { rootMargin: '200px 0px' }
      );
      this.observer.observe(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.measure();
      this.onScroll();
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    get scrubbing() {
      return this.mode === 'scrub' && !reduceMotion.matches && this.duration > 0;
    }

    pickVideo() {
      /* Desktopová a mobilní varianta jsou v DOM obě a přepínají se
         zobrazením. Ovládat se musí ta, která je zrovna vidět – jinak
         skript hýbe skrytým videem a na displeji se nic neděje. */
      var active = null;
      for (var i = 0; i < this.videos.length; i++) {
        if (this.videos[i].offsetParent !== null) {
          active = this.videos[i];
          break;
        }
      }
      if (!active) active = this.videos[0];
      if (active === this.video) return false;

      if (this.video) {
        this.video.pause();
        this.video.removeEventListener('loadedmetadata', this.onMeta);
      }
      this.video = active;
      this.current = 0;
      return true;
    }

    bindMeta() {
      if (this.video.readyState >= 1) {
        this.onMeta();
      } else {
        this.video.addEventListener('loadedmetadata', this.onMeta, { once: true });
      }
    }

    resolveMode() {
      /* Režim se liší pro desktop a mobil, ale atribut se médii řídit
         nedá – rozhoduje se proto podle šířky okna a přepočítává při
         změně velikosti, ať sedí i po otočení telefonu. */
      var breakpoint = parseInt(this.getAttribute('breakpoint'), 10) || 0;
      var attribute = breakpoint && window.innerWidth <= breakpoint ? 'mode-mobile' : 'mode';
      this.mode = this.getAttribute(attribute) || 'scrub';
    }

    onMeta() {
      this.duration = this.video.duration;
      if (!isFinite(this.duration) || this.duration <= 0) {
        this.duration = 0;
      }
      this.applyMode();
    }

    applyMode() {
      /* Neaktivní varianta se vždycky zastaví, ať na pozadí nehraje
         video, které není vidět. */
      for (var i = 0; i < this.videos.length; i++) {
        if (this.videos[i] !== this.video) this.videos[i].pause();
      }

      if (this.scrubbing) {
        this.video.loop = false;
        this.video.pause();
      } else {
        /* Bez scrubbingu se video chová jako obyčejná smyčka na pozadí. */
        this.video.loop = true;
        var played = this.video.play();
        if (played && played.catch) played.catch(function () {});
      }
    }

    unlock() {
      /* Safari na iOS nedekóduje snímky, dokud se video aspoň jednou
         nepřehraje. Bez tohohle zůstane plátno při přetáčení prázdné. */
      if (this.unlocked || !this.scrubbing) return;
      this.unlocked = true;
      var video = this.video;
      var played = video.play();
      if (played && played.then) {
        played.then(function () { video.pause(); }).catch(function () {});
      } else {
        video.pause();
      }
    }

    measure() {
      var rect = this.track.getBoundingClientRect();
      this.trackHeight = rect.height;
      this.scrollable = Math.max(1, this.trackHeight - window.innerHeight);
    }

    onResize() {
      var previous = this.mode;
      var swapped = this.pickVideo();
      this.resolveMode();
      if (swapped) this.bindMeta();
      if (swapped || previous !== this.mode) this.applyMode();
      this.measure();
      this.onScroll();
    }

    onScroll() {
      var top = this.track.getBoundingClientRect().top;
      this.progress = clamp(-top / this.scrollable, 0, 1);
      if (this.duration > 0) {
        this.target = this.progress * this.duration;
      }
      this.updateCaptions();
      if (this.visible) this.start();
    }

    updateCaptions() {
      for (var i = 0; i < this.captions.length; i++) {
        var el = this.captions[i];
        var from = parseFloat(el.getAttribute('data-sv-from')) / 100;
        var to = parseFloat(el.getAttribute('data-sv-to')) / 100;
        var fade = parseFloat(el.getAttribute('data-sv-fade')) / 100;
        var rise = parseFloat(el.getAttribute('data-sv-rise')) || 0;
        var p = this.progress;
        var opacity = 0;

        if (fade <= 0) {
          opacity = p >= from && p <= to ? 1 : 0;
        } else if (p >= from && p <= to) {
          opacity = 1;
        } else if (p < from && p > from - fade) {
          opacity = (p - (from - fade)) / fade;
        } else if (p > to && p < to + fade) {
          opacity = 1 - (p - to) / fade;
        }

        opacity = clamp(opacity, 0, 1);
        el.style.opacity = opacity;
        el.style.setProperty('--sv-rise', (1 - opacity) * rise + 'px');
        el.style.pointerEvents = opacity > 0.5 ? 'auto' : 'none';
      }
    }

    start() {
      if (!this.scrubbing || this.frame) return;
      this.frame = requestAnimationFrame(this.tick);
    }

    stop() {
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    }

    tick() {
      this.frame = null;
      var diff = this.target - this.current;

      /* Doskočení posledního zlomku sekundy by jen vyráběla práci navíc,
         prohlížeč ten rozdíl stejně nevykreslí. */
      if (Math.abs(diff) < 0.003) {
        this.current = this.target;
      } else {
        this.current += diff * this.smoothing;
        this.frame = requestAnimationFrame(this.tick);
      }

      if (this.video.readyState >= 1 && !isNaN(this.current)) {
        try {
          this.video.currentTime = this.current;
        } catch (e) {
          /* přetáčení může selhat, než je dost dat – příště to vyjde */
        }
      }
    }
  }

  if (!customElements.get('rizz-scroll-video')) {
    customElements.define('rizz-scroll-video', RizzScrollVideo);
  }
})();
